import React from "react";
import {
  Grid,
  TextField,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Radio,
  Tooltip,
  Typography,
  Paper,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import HelpIcon from "@material-ui/icons/Help";
import styled from "styled-components";
import { withStyles } from '@material-ui/core/styles';

const fileTypeOptions = [
  "image/*",
  "video/*",
  "audio/*",
  "application/pdf",
  "text/plain",
  ".doc, .docx",
  ".xls, .xlsx",
  ".ppt, .pptx",
  ".csv",
];

const CustomPaper = (props) => {
  return <Paper elevation={8} {...props} />;
};


function FileColumnConfig(props) {
  const { values, handleChange, setFieldValue, isAdditionalOptions } = props;

  React.useEffect(() => {
    if (values.options.max_files === undefined) {
      setFieldValue("options.max_files", 20);
    }
    if (values.options.file_permission === undefined) {
      setFieldValue("options.file_permission", "public");
    }
    if (values.options.allowed_file_types === undefined) {
      setFieldValue("options.allowed_file_types", []);
    }
  }, [setFieldValue, values.options]);

  if (!isAdditionalOptions) {
    return null;
  }

  return (
    <ConfigContainer>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Autocomplete
            multiple
            id="allowed-file-types"
            options={fileTypeOptions}
            disableCloseOnSelect
            disablePortal
            PaperComponent={CustomPaper}
            getOptionLabel={(option) => option}
            value={values.options.allowed_file_types || []}
            onChange={(event, newValue) => {
              setFieldValue("options.allowed_file_types", newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Allowed File Types"
                size="small"
              />
            )}
            ListboxProps={{
                style: { maxHeight: 200 },
            }}
          />
          <Typography variant="caption" color="textSecondary" style={{ marginTop: '4px', display: 'block' }}>
            Leave empty to allow all file types.
          </Typography>
        </Grid>
        <Grid item container>
          <Grid item xs={6}>
            Max Files:
          </Grid>
          <TextField
            variant="outlined"
            name="options.max_files"
            value={values.options["max_files"] ?? ""}
            onChange={handleChange}
            size="small"
            style={{ maxWidth: 50 }}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            <FormLabel component="legend">File Permission</FormLabel>
            <RadioGroup
              aria-label="file_permission"
              name="options.file_permission"
              value={values.options["file_permission"] ?? ""}
              onChange={handleChange}
            >
              <FormControlLabel
                value="public"
                control={<Radio />}
                label={
                  <Tooltip title="Anyone with the file link can view the file">
                    <RadioLabel>
                      Public
                      <HelpIcon />
                    </RadioLabel>
                  </Tooltip>
                }
              />
              <FormControlLabel
                value="private"
                control={<Radio />}
                label={
                  <Tooltip title="Only shared users of this sheet has access to the file">
                    <RadioLabel>
                      Private <HelpIcon />
                    </RadioLabel>
                  </Tooltip>
                }
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </ConfigContainer>
  );
}

export default FileColumnConfig;

const ConfigContainer = styled.div`
  width: 100%;
  max-width: 280px;
`;

const RadioLabel = styled.span`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
`;
